/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdorSupportPage from '../Components/AdorSupport';
import Layout from '../Components/Layout';
import { Login } from '../Components/Login';
import Transactionlist from '../Pages/AdorCashTransactions/transactionlist';
import BulkOffer from '../Pages/BulkOffer';
import BulkOfferListing from '../Pages/BulkOffer';
import ViewBulkOffer from '../Pages/BulkOffer/viewBulkOffer';
import CartManagement from '../Pages/CartManagement';
import HomePage from '../Pages/HomePage';
import ListOfInvoices from '../Pages/ListOfInvoices';
import MangeAssistantUsers from '../Pages/ManageAssistantUser';
import IndentReport from '../Pages/MISReports/IndentReport';
import InvoiceReport from '../Pages/MISReports/InvoiceReport';
import OutstandingInvoiceReport from '../Pages/MISReports/OutstandingInvoiceReport';
import OutstandingReport from '../Pages/MISReports/OutstandingReport';
import PendingOrderStatementReport from '../Pages/MISReports/PendingOrderStatementReport';
import MyOrders from '../Pages/MyOrders';
import ViewOrder from '../Pages/MyOrders/ViewOrder';
import OfferDetails from '../Pages/OfferDetails';
import { Offers } from '../Pages/Offers';
import ProductDetail from '../Pages/ProductDetail';
import ManageProducts from '../Pages/ProductsList';
import Profile from '../Pages/Profile';
import AdorSupport from '../Pages/Profile/AdorSupport';
import Resources from '../Pages/Resources';
import Wish from '../Pages/Wishlist';
import BulkOfferDetails from '../Pages/BulkOffer/OfferDetails/index'
import TermsAndConditions from '../Pages/Policies/TermsAndConditions';
import PrivacyPolicy from '../Pages/Policies/PrivacyPolicy';
import ReturnPolicy from '../Pages/Policies/ReturnPolicy';
import PricingPolicy from '../Pages/Policies/PricingPolicy';
import ShippingPolicy from '../Pages/Policies/ShippingPolicy';
import ManageCreditDebitDetails from '../Pages/CreditDebitDetails';

export default function NavigationRoutes(props) {
    const { loggedIn } = props;
    const allRoutes = {
        "bulk_deal_visibility": <Route path="/bulk-offer" element={<BulkOffer />} />,
        "resources_visibility": <Route path="/manage-resource" element={<Resources />} />,
        "ador_cash_ledger": <Route path="/list-of-transactions" element={<Transactionlist />} />,
        "manage_assistant_user": <Route path="/manage-assistant-users" element={<MangeAssistantUsers />} />,
        "credit_debit:list": <Route path="/mis-reports/credit-debit-details" element={<ManageCreditDebitDetails />} />,
    }
    let privilages = [
        <Route path="/" element={<HomePage />} />,
        <Route path="/profile" element={<Profile />} />,
        <Route path="/products" element={<ManageProducts />} />,
        <Route path="/products/:id/view" element={<ProductDetail />} />,
        <Route path="/wishlist" element={<Wish />} />,
        <Route path="/offers" element={<Offers/>} />,
        <Route path="/cart" element={<CartManagement/>} />,
        <Route path="/offers/:id" element={<OfferDetails/>} />,
        <Route path="/special-recurring-offers/:id" element={<OfferDetails specialRecurring/>} />,
        <Route path="/orders" element={<MyOrders />} />,
        <Route path="/orders/:id/view" element={<ViewOrder/>} />,
        <Route path="/invoices" element={<ListOfInvoices />} />,
        <Route path="/mis-reports/pending-order-statement-report" element={<PendingOrderStatementReport />} />,
        <Route path="/mis-reports/invoice-report" element={<InvoiceReport />} />,
        <Route path="/mis-reports/indent-report" element={<IndentReport />} />,
        <Route path="/mis-reports/outstanding-report" element={<OutstandingReport />} />,
        <Route path="/mis-reports/outstanding-invoice-details-report" element={<OutstandingInvoiceReport />} />,
        <Route path="/ador-support" element={<AdorSupportPage />} />,
        // <Route path="/bulk-offer" element={<BulkOffer />} />,
        <Route path="/bulk-offers/:id" element={<BulkOfferDetails />} />,
        <Route path="/bulk-offers/:id/:subscription" element={<BulkOfferDetails />} />,
    ];
    if (loggedIn) 
    {
        const currentUserPrevilages = JSON.parse(localStorage.getItem('user'))?.profile?.PRIVILAGES || [];
        for (let index = 0; index < currentUserPrevilages.length; index++) {
            if (Object.keys(allRoutes).includes(currentUserPrevilages[index]) && typeof allRoutes[currentUserPrevilages[index]] === typeof []) {
                privilages = privilages.concat(allRoutes[currentUserPrevilages[index]]);
            } else if (Object.keys(allRoutes).includes(currentUserPrevilages[index]) && typeof allRoutes[currentUserPrevilages[index]] !== typeof []) {
                privilages.push(allRoutes[currentUserPrevilages[index]]);
            }
        }
    }


    return (
        <Routes>
            {!loggedIn ? (
                <Route path="/" element={<Login />} />
            ) : (
                <Route element={<Layout {...props} />}>
                    {privilages}
                    {/* <Route path="/" element={<HomePage />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/manage-assistant-users" element={<MangeAssistantUsers />} />
                    <Route path="/products" element={<ManageProducts />} />
                    <Route path="/products/:id/view" element={<ProductDetail />} />
                    <Route path="/wishlist" element={<Wish />} />
                    <Route path="/offers" element={<Offers/>} />
                    <Route path="/cart" element={<CartManagement/>} />
                    <Route path="/offers/:id" element={<OfferDetails/>} />
                    <Route path="/orders" element={<MyOrders />} />
                    <Route path="/orders/:id/view" element={<ViewOrder/>} />
                    <Route path="/invoices" element={<ListOfInvoices />} />
                    <Route path="/manage-resource" element={<Resources />} />
                    <Route path="/list-of-transactions" element={<Transactionlist />} />
                    <Route path="/mis-reports/pending-order-statement-report" element={<PendingOrderStatementReport />} />
                    <Route path="/mis-reports/invoice-report" element={<InvoiceReport />} />
                    <Route path="/mis-reports/indent-report" element={<IndentReport />} />
                    <Route path="/mis-reports/outstanding-report" element={<OutstandingReport />} />
                    <Route path="/mis-reports/outstanding-invoice-details-report" element={<OutstandingInvoiceReport />} />
                    <Route path="/ador-support" element={<AdorSupportPage />} />
                    <Route path="/bulk-offer" element={<BulkOffer />} />
                    <Route path="/bulk-offers/:id" element={<BulkOfferDetails />} />
                    <Route path="/bulk-offers/:id/:subscription" element={<BulkOfferDetails />} /> */}
                </Route>
            )}
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/pricing-policy" element={<PricingPolicy />} />
            <Route path="/return-policy" element={<ReturnPolicy />} />
            <Route
                path="*"
                element={(
                    <main style={{ padding: '1rem' }}>
                        <p>There's nothing here!</p>
                        <a><Navigate to="/" replace /></a>
                    </main>
                )}
            />
        </Routes>

    );
}
